import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { IProvider } from 'modules/security/roles/interfaces/IProvider';

class ProviderService extends EntityApiService<IProvider> {
  searchProvidersByType = (providerType: string, params?: any, config?: RequestConfig) => {
    if (providerType === 'logistics' || providerType === 'suppliers') {
      return this.handleResponse(
        ApiClientService.post(this.getPath(`/${providerType}/search`), { ...params, size: 100 }, config),
      );
    }
    return this.handleResponse(
      ApiClientService.post(`/ms-inventory/api/${providerType}/search`, { ...params, size: 100 }, config),
    );
  };

  getOneByType = (id: string, params: string) => {
    if (params === 'logistics' || params === 'suppliers') {
      return this.handleResponse(ApiClientService.get(this.getPath(`/${params}/${id}`)));
    }
    return this.handleResponse(ApiClientService.get(`/ms-inventory/api/${params}/${id}`));
  };
}

export default new ProviderService('/ms-inventory/api/provider');
